<template>
  <v-card>
    <vue-card-title
      :title="'Manage Sales Team'"
      :subtitle="'Refer to the following information managing the sales team.'"
      :icon="$getIcon('mdiClipboardTextOutline')"
    >
      <template slot="actions">
        <v-btn
          class="indigo accent-2 white--text text-capitalize my-0"
          small
          @click="salesTeamForm = true"
        >
          Create Team
        </v-btn>
      </template>
    </vue-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row v-if="!fetched">
        <v-col cols="12">
          <vue-default-svg-loader></vue-default-svg-loader>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <vue-pagination-component
            :fetch-api.sync="fetchAPI"
            :search-label="searchLabel"
            :query-params.sync="queryParams"
            :filter-query="queryParams"
            :next-link="nextLink"
            :previous-link="previousLink"
            :pagination-info="paginationInfo"
          ></vue-pagination-component>
        </v-col>
        <v-col v-if="fetchedData.length < 1 && filtered" cols="12">
          Search results not found.
        </v-col>
        <v-col v-else-if="fetchedData.length < 1" cols="12">
          <vue-no-data></vue-no-data>
        </v-col>
        <v-col
          v-for="(team, index) in fetchedData"
          v-else
          :key="index"
          class="text-center"
          md="3"
          cols="12"
        >
          <v-card>
            <vue-card-title :title="team.name"> </vue-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <a
                class="font-0 grey--text cursor-pointer"
                @click="
                  (selectedSalesTeamData = team) && (salesTeamForm = true)
                "
                >Update</a
              >
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- Sales Team Form -->
    <v-bottom-sheet v-model="salesTeamForm" scrollable>
      <v-card tile>
        <vue-card-title
          :title="cardTitle"
          :subtitle="'Fill up the following form to action on sales team form.'"
          :icon="$getIcon('mdiFileDocumentEdit')"
          closable
          @close="salesTeamForm = false"
        >
        </vue-card-title>
        <v-divider></v-divider>
        <v-card-text class="form-scroll scrollable">
          <sales-team-form
            v-if="selectedSalesTeamData && salesTeamForm"
            :action-data="selectedSalesTeamData"
            @salesTeamFormResponse="formSuccess"
          >
          </sales-team-form>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
    <!-- / Sales Team Form -->
  </v-card>
</template>
<script>
import PaginationMixin from "@/mixins/paginationSearchMixin";
import SalesTeamForm from "@/components/crm/sales_team/forms/SalesTeamForm";

export default {
  components: {
    SalesTeamForm
  },
  mixins: [PaginationMixin],
  data() {
    return {
      // pagination Mixin
      searchLabel: "Search for sales teams",
      // sales team form
      salesTeamForm: false,
      selectedSalesTeamData: {},
      cardTitle: "",
      organizationSlug: this.$store.state.shell.currentOrganizationId
    };
  },
  computed: {
    fetchAPI() {
      return `/api/v1/crm/teams/?organization__slug=${this.organizationSlug}`;
    }
  },
  watch: {
    salesTeamForm(newVal) {
      if (Object.keys(this.selectedSalesTeamData).length > 0 && newVal) {
        this.cardTitle = "Update Sales Team";
      } else {
        this.selectedSalesTeamData = {};
        this.cardTitle = "Create Sales Team";
      }
    }
  },
  methods: {
    formSuccess() {
      this.salesTeamForm = false;
      this.fetchData();
    }
  }
};
</script>
